import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-about-custom',
    templateUrl: '../../../custom/about/about.html',
    styleUrls: ['../../../custom/about/about.css'],
})
export class AboutCustomComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
